export const DEFAULT_ADVANCE_BUTTON_STYLE =
  'bg-main-100 enabled:hover:bg-main-200 text-white rounded-lg text-sm font-normal py-2 px-5 disabled:opacity-50 disabled:cursor-not-allowed';
export const DEFAULT_CANCEL_BUTTON_STYLE =
  'bg-secondary-100 enabled:hover:bg-secondary-200 text-main-100 rounded-lg text-sm font-normal py-2 px-5 disabled:opacity-50 disabled:cursor-not-allowed';
export const RAISED_DIALOG = 'm-auto bg-white rounded-2xl border shadow-lg p-8';
export const INPUT_STYLE =
  'w-full h-[2.5rem] border border-gray-300 bg-white rounded-md focus:ring-blue-500 focus:border-blue-500 p-2';
export const MULTILINE_INPUT_STYLE =
  'w-full border border-gray-300 bg-white rounded-md focus:ring-blue-500 focus:border-blue-500 p-2';
export const SELECT_INPUT_STYLE =
  'flex w-[20rem] m-auto py-2 px-4 my-4 text-[14px] text-gray-700 leading-tight border border-gray-300 rounded-md bg-white focus:outline-none focus:shadow-outline-blue';
export const BORDER_STYLE = 'border border-1 border-grey-2 rounded-lg';
export const MODAL_CONTENT_STYLE = {
  borderRadius: '16px',
  border: '2px solid #F7F7F7',
  padding: '2.5rem'
};
